import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import "./ToggleSwitchStyles.css";
import { Actions } from "../../Action/index";
import SwitchComp from '../../NewComponent/Switch/Switch';
export default function VizToggleSwitch() {
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { toggleAISwitch } = bindActionCreators(Actions, dispatch);
  const [isToggle, setIsToggle] = React.useState(userState.searchToggle);
  const onChangeToggleAI = (e) => {
    console.log(e);
    setIsToggle(e);
    toggleAISwitch(e);
  };
  return (
    <>
    <SwitchComp val={isToggle} onChangeFunc={onChangeToggleAI}/>
    </>
  );
}
